import { SupportedLocale } from '@src/cnst/translations.cnst'
import {
  Popup,
  PopupContent,
  PopupProps,
  PopupTriggers,
  PopupTriggerScroll,
} from '@src/components/popup/Popup.component'
import { languageContext } from '@src/context/language.context'
import type { ReactNode } from 'react'
import { useContext } from 'react'

export interface PopupHomepageProps {
  popups: PopupContent[]
}

export function PopupHomepage({ popups }: PopupHomepageProps): ReactNode {
  // Only if the Swedish content exists in Dato
  // we display the Swedish popup on the Swedish page
  const svContentExist = !!popups[1]

  const { locale } = useContext(languageContext)
  const localizedContent: PopupContent =
    locale === SupportedLocale.svSE && svContentExist ? popups[1]! : popups[0]!

  const trigger: PopupTriggerScroll = {
    type: PopupTriggers.Scroll,
    scrollPercentage: 25,
  }

  const popup: PopupProps = {
    ...localizedContent,
    trigger,
  }

  if (locale === SupportedLocale.svSE && !svContentExist) {
    return <></>
  }
  return <Popup {...popup} />
}
